export default "__VITE_ASSET__D8mYeJWX__"